export interface RandomStringOptions {
  length?: number;
  uppercase?: boolean;
  lowercase?: boolean;
  symbols?: boolean;
  digits?: boolean;
}

export function isNotBlank(str: unknown): boolean {
  if (typeof str !== 'string') {
    return false;
  }
  return str.trim() !== '';
}

export function isBlank(str: unknown): boolean {
  if (str === null || str === undefined) {
    return true;
  }
  if (typeof str !== 'string') {
    return false;
  }
  return str.trim() === '';
}

export function generateRandomString(options: RandomStringOptions = {}): string {
  const {
    length = 8,
    uppercase = true,
    lowercase = true,
    symbols = false,
    digits = true
  } = options;

  let chars = '';
  if (uppercase) chars += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  if (lowercase) chars += 'abcdefghijklmnopqrstuvwxyz';
  if (symbols) chars += '!@#$%^&*';
  if (digits) chars += '0123456789';

  if (!chars) throw new Error('At least one character set must be enabled');

  let result = '';
  const randomBytes = new Uint32Array(length);
  window.crypto.getRandomValues(randomBytes);
  for (let i = 0; i < length; i++) {
    result += chars[randomBytes[i] % chars.length];
  }
  return result;
}

export default {
  isNotBlank,
  isBlank,
  generateRandomString
};
